import ROUTE_NAME from "@/router/router.const";

export default {
  path: "/",
  redirect: { name: ROUTE_NAME.LOGIN },
};
